import React from 'react';
import Header from "../components/custom/header";
import RequestTrackingDetail from "../components/request-tracking-detail/request-tracking-detail";

const RequestTrackingDetailPage = (props) => {

    return (

        <div>
            <Header />
            <RequestTrackingDetail />
        </div>
    )
}


export default (RequestTrackingDetailPage);
